import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'spk-tabs',
  templateUrl: './spk-tabs.component.html',
  styleUrls: ['./spk-tabs.component.scss']
})
export class SpkTabsComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/framework/spk/layouts/tabs/spk-tabs/spk-tabs.component.ts